var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTime)?_c('div',{staticClass:"time"},[_c('div',{staticClass:"time-item"},[_vm._v(" "+_vm._s(_vm.time)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }